import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import CircularProgress from '@material-ui/core/CircularProgress';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Input = lazy(() => import(`globalcomponents/UI/Input/${layout}`));
const Label = lazy(() => import(`globalcomponents/UI/FormLabel/${layout}`));
const Message = lazy(() => import(`globalcomponents/UI/Message/${layout}`));
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const FormStyle = require(`globalcomponents/UI/Form/${layout}/serverStyle`).default;
const RenderComponent = ({
  values,
  handleEdit,
  errors,
  isNotValid,
  validateForm,
  customProps: { i18n, hasApiStatus },
  submitAction
}) => {
  return (
    <>
      {hasApiStatus?.errorMessage && (
        <Message type="error" className="errorMessage" message={i18n.t(hasApiStatus.errorMessage)} />
      )}
      <FormStyle.FieldsWrapper width="100%">
        <Label mode="light" className="labelSize">
          {i18n.t('common.mfacode')}
        </Label>
        <FormStyle.TextWrapper>
          <Field
            name="email"
            handleOnChange={(event) =>
              handleEdit(event, { field: 'mfacode', type: 'mfacode' })
            }
            as={Input}
            placeholder={i18n.t('MFA code')}
            value={values.mfacode}
            type="text"
            mode="light"
          />
          {errors['mfacode'] && !isNotValid && (
            <Message type="error" message={errors['mfacode']} />
          )}
        </FormStyle.TextWrapper>
      </FormStyle.FieldsWrapper>

      <FormStyle.ButtonsWrapper>
        <Button
          type="submit"
          label={
            hasApiStatus?.isLoading ? (
              <CircularProgress color="inherit" />
            ) : (
              i18n.t('common.authenticate')
            )
          }
          onClick={() => {
            const validateResponse = validateForm();
            validateResponse.then((data) => submitAction(data));
          }}
        />
      </FormStyle.ButtonsWrapper>
    </>
  );
};

export default RenderComponent;

RenderComponent.propTypes = {
  values: PropTypes.object.isRequired,
  handleEdit: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  isNotValid: PropTypes.bool.isRequired,
  customProps: PropTypes.object,
  validateForm: PropTypes.func.isRequired,
  submitAction: PropTypes.func.isRequired
};
